import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { I1379Form } from 'clickNgo/models/crud/forms/i1379Form'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IGlobalPartner } from '../../models/globalPartner'

import { mapGlobalPartnerFrom1379Crud } from './mapping/mapGlobalPartnerFrom1379Crud'

export const fetchGlobalPartnerById = (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IGlobalPartner> => {
  const partnerCrud = CrudStore.get<I1379Form>(
    CrudStoreItemPartner360.JBPGlobalPartnerData,
    options?.cacheKey
  )
  const keyField = 'GlobalPartnerId'
  return partnerCrud
    .getById({ id: partnerId, force: options?.isForce, keyField })
    .then((result) => result && mapGlobalPartnerFrom1379Crud(result))
    .catch((error) => Logger.error(error))
}
